import '.cc{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.jk{padding:0.6rem;}.ssr-plugin'
import '.i5{border-radius:1.875rem;}.ssr-plugin'
import '.jl{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.jm{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.jn{--page-min-height:auto;}.ssr-plugin'
import '.dp{border-radius:2rem;}.ssr-plugin'
import '.jo{overflow-x:hidden;}.ssr-plugin'
import '.bv{overflow-y:auto;}.ssr-plugin'
import '.jp{background:var(--page-bg);}.ssr-plugin'
import '.ab{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cc e t v jk i5 jl jm"
      style={{
        ...style,
      }}
    >
      <styled.div className="jn dp jo bv jp ab"
        style={{
          width,
          height,} as Style}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
